module.exports = __webpack_public_path__ + "img/icon4-2@2x.a2b5ed8f.png";